<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="500px">
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title>
            <span class="headl">BORRAR PRODUCTO</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <p>
                    Está a punto de eliminar la categoria con nombre
                    <b>{{ datos.name }}</b> , si la acción es correcta escriba
                    el nombre de la tienda, recuerde que esto es irreversible y
                    no podrá recuperar la tienda.
                  </p>
                  <v-text-field
                    ref="name"
                    v-model="name"
                    :rules="[nameRules.required, nameRules.equal]"
                    label="Nombre del producto"
                    required
                  ></v-text-field>
                  <p class="msj-alert-delete" v-if="this.alert != null">
                    El nombre no coincide.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn large text @click.stop="show = false">Cerrar</v-btn>
              <v-btn
                :disabled="!valid"
                depressed
                large
                class="red_delete"
                @click="validate"
                >ELIMINAR</v-btn
              >
            </div>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
//import AlertMsj from '@/components/dashboard/AlertMsj.vue';

export default {
  name: 'DeleteProduct',
  props: ['visible', 'datos'],
  data() {
    return {
      userID: null,
      name: null,
      nameRules: {
        required: (v) => !!v || 'El nombre es requerido',
        equal: (v) => v === this.datos.name || 'El nombre no coincide.',
      },
      valid: true,
      alert: null,
    };
  },
  mounted() {
    this.userID = this.userId;
    //this.itemsCategories = this.getCateShop
  },

  methods: {
    ...mapActions(['deleteProduct', 'alertGeneral']),

    validate() {
      if (this.$refs.form.validate()) {
        this.registerShop();
      }
    },
    registerShop() {
      try {
        if (this.name != this.datos.name) {
          this.alert = 'El nombre no coincide.';
        } else {
          const params = new URLSearchParams();
          params.append('_id', this.datos._id);
          params.append('user', this.userID);

          this.deleteProduct(params);
          // close modal
          this.show = false;
          // reset form
          this.alert = null;
          this.$refs.form.reset();
          // update table shop
          this.alertGeneral({
            flat: true,
            msj: 'La categoria se ha eliminado correctamente.',
          });
        }
      } catch (error) {
        this.alertGeneral({
          flat: true,
          msj: '¡Huy! Ocurrió un error, inténtelo más tarde.',
        });
        this.errmensaje = 'Ops! ocurrio un error con el servidor';
      }
    },
  },
  computed: {
    ...mapGetters(['userId']),
    isActive() {
      return this.valid;
    },

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>

<style lang="scss">
span.headl {
  font-family: 'Roboto Condensed', sans-serif !important;
  font-size: 1.5rem !important;
}
.ctn_btn_shop {
  button.v-btn {
    min-width: 120px !important;
  }

  .red_delete {
    background-color: red !important;
    color: #fff !important;
  }
}
.msj-alert-delete {
  margin: 0;
  color: red;
}
</style>
